import { OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from 'src/app/providers/navigation.service';
import { AddUnavailabilitySettingsComponent } from '../new-v2-component/add-unavailability-settings/add-unavailability-settings.component';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';

@Component({
  selector: 'sm-entity-unavailability',
  templateUrl: './entity-unavailability.component.html',
  styleUrls: ['./entity-unavailability.component.scss']
})
export class EntityUnavailabilityComponent implements OnInit,OnDestroy {
  
  apisub: Subscription
  loader:boolean = false
  unavailabilityData:any = []  
  constructor(
    private navservice: NavigationService,
    private dialog: MatDialog,
    private route:ActivatedRoute,
    private apiservice:ApiService,
    private ls:LoaderServiceService
   ){
    this.navservice.hideSidebarAndNav = false
    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_UNAVAILABILITY_LIST_OF_ENTITY){
        this.unavailabilityData = []
        if(resdata.result){
          this.unavailabilityData = resdata.result
          
        } 
        this.ls.showLoader = false
        this.loader = false
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_REMOVE_UNAVAILABILITY_FOR_ENTITY){
        
        if(resdata.result){
          // this.unavailabilityData = resdata.result
          this.apiservice.getUnavailabilityListOfEntity(this.entityHash,this.serviceType)
        } 
      }
    })
  }
  serviceType:any
  entityHash:any
  ngOnInit(): void {
    this.route.queryParams.subscribe(data => {
      if(data.serviceType){
        this.serviceType = data.serviceType
        this.entityHash = data.entityHash
      }
    })

    this.loader = true
    this.ls.showLoader = true
    this.apiservice.getUnavailabilityListOfEntity(this.entityHash,this.serviceType)
  }

  openModal(){
    // let data = {
    
    // }

   let dialogref =  this.dialog.open(AddUnavailabilitySettingsComponent,{
      data:{
        serviceType: this.serviceType,
        entityHash: this.entityHash
      }
    })
    dialogref.afterClosed().subscribe(data => {
      if(data){
        this.apiservice.getUnavailabilityListOfEntity(this.entityHash,this.serviceType)
      }
    })
  }
  tConv24(time24: any) {
    let ts: any = time24;
    let H: any = +ts.substr(0, 2);
    let h: any = H % 12 || 12;
    h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " AM" : " PM";
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  }
  deleteData(item:any){
     const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message: "Are you sure you want to delete this data?",
            okbtn: "Yes",
            cancelbtn: "No",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
    dialogRef.afterClosed().subscribe(dat => {
      if(dat){
        let bodydata = {
          "entityHash": this.entityHash,
          "hashId": item.hash_id
        }
    
        this.ls.showLoader = true
        this.apiservice.removeUnavailabilityForEntity(bodydata)

      }
    })        
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }
}
